// Paid listing tiers: Featured (top of search + «ویژه» badge) and Premium (also a homepage spot).
export const FEATURED_LABEL = 'ویژه';
export const FEATURED_COLOR = '#b7791f';   // badge background (amber/gold)
export const FEATURED_OUTLINE = '#d69e2e'; // card outline
export const PREMIUM_LABEL = 'برگزیده';
export const PREMIUM_COLOR = '#6b21a8';    // badge background (deep purple)
export const PREMIUM_OUTLINE = '#9333ea';  // card outline
